import React, { useState } from "react";

function DataConfirm({ user, dataCheck, dataUpdate, webSetting }) {
  const [copySuccess, setCopySuccess] = useState("");
  const mailTo = webSetting.email;
  let phoneNumber = webSetting.phone_number;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const updateName = {
    title: `THAY ĐỔI TÊN TÀI KHOẢN`,
    content: `Tên đăng nhập: ${user.account}\r\nHọ tên cũ: ${dataCheck.name}\r\nHọ tên mới: ${dataUpdate.name}\r\nNgân hàng: ${dataCheck.bank_number}-${dataCheck.bank_name}`,
  };
  const updatePhoneNumber = {
    title: `THAY ĐỔI SỐ ĐIỆN THOẠI`,
    content: `Tên đăng nhập: ${user.account}\r\nSố điện thoại mới: ${dataUpdate.phone_number}`,
  };
  const updateBank = {
    title: `THAY ĐỔI TÀI KHOẢN NGÂN HÀNG`,
    content: `Tên đăng nhập: ${user.account}\r\nNgân hàng mới: ${dataUpdate.bank_number}-${dataUpdate.bank_name}`,
  };
  const updateEmail = {
    title: `THAY ĐỔI EMAIL`,
    content: `Tên đăng nhập: ${user.account}\r\nEmail mới: ${dataUpdate.email}`,
  };
  const copyToClipboardAndSendMailSMS = async (textUpdate) => {
    try {
      await navigator.clipboard.writeText(textUpdate.content);
      setCopySuccess("Đã sao chép nội dung.");
      setTimeout(() => {
        setCopySuccess("");
      }, 30000);
      if (user.send_type === "phone_number") {
        const smsLink = `sms:${phoneNumber}?body=${encodeURIComponent(textUpdate.content)}`;
        window.location.href = smsLink;
      }
    } catch (err) {
      setCopySuccess("Sao chép không thành công.");
      console.error("Không thể sao chép văn bản: ", err);
    }
  };

  const SendButton = ({send_type, isMobile, mailTo, phoneNumber, textUpdate }) => {
    return (
      send_type === "email" ? (
      <a
        href={isMobile 
          ? `mailto:${mailTo}?subject=${encodeURIComponent(textUpdate.title)}&body=${encodeURIComponent(textUpdate.content)}`
          : `https://mail.google.com/mail/?view=cm&fs=1&to=${mailTo}&su=${encodeURIComponent(textUpdate.title)}&body=${encodeURIComponent(textUpdate.content)}`
        }
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center min-w-[120px] sm:min-w-[140px] h-9 sm:h-10 px-4 sm:px-5 text-xs sm:text-sm font-semibold text-blue-600 bg-white border-2 border-blue-500 rounded-[20px] sm:rounded-[25px] hover:bg-blue-50 hover:scale-105 transition-all duration-200 no-underline cursor-pointer"
      >
        Gửi Email
      </a>
      ) : isMobile && (
      <a
        href={`sms:${phoneNumber}?body=${encodeURIComponent(textUpdate.content)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center min-w-[120px] sm:min-w-[140px] h-9 sm:h-10 px-4 sm:px-5 text-xs sm:text-sm font-semibold text-blue-600 bg-white border-2 border-blue-500 rounded-[20px] sm:rounded-[25px] hover:bg-blue-50 hover:scale-105 transition-all duration-200 no-underline cursor-pointer"
      >
        Gửi Tin Nhắn
      </a>
      )
    );
  };

  switch (user.update_type) {
    case "full_name": {
      const textUpdate = updateName;
      return (
        <div className="w-full flex flex-col gap-2.5 sm:gap-3">
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Tên tài khoản: <span className="font-semibold text-[#2F3945]">{user.account}</span></span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Họ và tên cũ: <span className="font-semibold text-[#2F3945]">{dataCheck.name}</span></span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Họ và tên mới: <span className="font-semibold text-[#2F3945]">{dataUpdate.name}</span></span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Số tài khoản: <span className="font-semibold text-[#2F3945]">{dataCheck.bank_number} - Ngân hàng {dataCheck.bank_name}</span></span>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 sm:gap-3 mt-3 sm:mt-4">
            <div className="flex flex-col items-center gap-1.5 w-full sm:w-auto">
              <button 
                onClick={() => copyToClipboardAndSendMailSMS(textUpdate)}
                className="w-full sm:w-auto min-w-[140px] sm:min-w-[160px] h-9 sm:h-10 px-4 sm:px-5 text-xs sm:text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-blue-600 rounded-[20px] sm:rounded-[25px] hover:from-blue-600 hover:to-blue-700 hover:scale-105 transition-all duration-200 cursor-pointer"
              >
                Sao chép nội dung
              </button>
              {copySuccess && (
                <p className="text-[11px] sm:text-xs text-green-600 font-medium text-center">{copySuccess}</p>
              )}
            </div>
            <SendButton
              send_type={user.send_type}
              isMobile={isMobile}
              mailTo={mailTo}
              phoneNumber={phoneNumber}
              textUpdate={textUpdate}
            />
          </div>
        </div>
      );
    }
    case "phone_number": {
      const textUpdate = updatePhoneNumber;
      return (
        <div className="w-full flex flex-col gap-2.5 sm:gap-3">
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Tên tài khoản: <span className="font-semibold text-[#2F3945]">{user.account}</span></span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Số điện thoại mới: <span className="font-semibold text-[#2F3945]">{dataUpdate.phone_number}</span></span>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 sm:gap-3 mt-3 sm:mt-4">
            <div className="flex flex-col items-center gap-1.5">
              <button 
                onClick={() => copyToClipboardAndSendMailSMS(textUpdate)}
                className="w-full sm:w-auto min-w-[140px] sm:min-w-[160px] h-9 sm:h-10 px-4 sm:px-5 text-xs sm:text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-blue-600 rounded-[20px] sm:rounded-[25px] hover:from-blue-600 hover:to-blue-700 hover:scale-105 transition-all duration-200 cursor-pointer"
              >
                Sao chép nội dung
              </button>
              {copySuccess && (
                <p className="text-[11px] sm:text-xs text-green-600 font-medium">{copySuccess}</p>
              )}
            </div>
            <SendButton
              send_type={user.send_type}
              isMobile={isMobile}
              mailTo={mailTo}
              phoneNumber={phoneNumber}
              textUpdate={textUpdate}
            />
          </div>
        </div>
      );
    }
    case "email": {
      const textUpdate = updateEmail;
      return (
        <div className="w-full flex flex-col gap-2.5 sm:gap-3">
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Tên tài khoản: <span className="font-semibold text-[#2F3945]">{user.account}</span></span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Email mới: <span className="font-semibold text-[#2F3945]">{dataUpdate.email}</span></span>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 sm:gap-3 mt-3 sm:mt-4">
            <div className="flex flex-col items-center gap-1.5">
              <button 
                onClick={() => copyToClipboardAndSendMailSMS(textUpdate)}
                className="w-full sm:w-auto min-w-[140px] sm:min-w-[160px] h-9 sm:h-10 px-4 sm:px-5 text-xs sm:text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-blue-600 rounded-[20px] sm:rounded-[25px] hover:from-blue-600 hover:to-blue-700 hover:scale-105 transition-all duration-200 cursor-pointer"
              >
                Sao chép nội dung
              </button>
              {copySuccess && (
                <p className="text-[11px] sm:text-xs text-green-600 font-medium">{copySuccess}</p>
              )}
            </div>
            <SendButton
              send_type={user.send_type}
              isMobile={isMobile}
              mailTo={mailTo}
              phoneNumber={phoneNumber}
              textUpdate={textUpdate}
            />
          </div>
        </div>
      );
    }
    case "bank": {
      const textUpdate = updateBank;
      return (
        <div className="w-full flex flex-col gap-2.5 sm:gap-3">
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Tên tài khoản: <span className="font-semibold text-[#2F3945]">{user.account}</span></span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Số tài khoản: <span className="font-semibold text-[#2F3945]">{dataUpdate.bank_number} - Ngân hàng {dataUpdate.bank_name}</span></span>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 sm:gap-3 mt-3 sm:mt-4">
            <div className="flex flex-col items-center gap-1.5">
              <button 
                onClick={() => copyToClipboardAndSendMailSMS(textUpdate)}
                className="w-full sm:w-auto min-w-[140px] sm:min-w-[160px] h-9 sm:h-10 px-4 sm:px-5 text-xs sm:text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-blue-600 rounded-[20px] sm:rounded-[25px] hover:from-blue-600 hover:to-blue-700 hover:scale-105 transition-all duration-200 cursor-pointer"
              >
                Sao chép nội dung
              </button>
              {copySuccess && (
                <p className="text-[11px] sm:text-xs text-green-600 font-medium">{copySuccess}</p>
              )}
            </div>
            <SendButton
              send_type={user.send_type}
              isMobile={isMobile}
              mailTo={mailTo}
              phoneNumber={phoneNumber}
              textUpdate={textUpdate}
            />
          </div>
        </div>
      );
    }
    default: {
      const textUpdate = updateBank;
      return (
        <div className="w-full flex flex-col gap-2.5 sm:gap-3">
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Tên tài khoản: <span className="font-semibold text-[#2F3945]">{user.account}</span></span>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 py-1.5 sm:py-2">
            <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-[13px] sm:text-[14px] md:text-[15px] font-medium text-[#2F3945]">Số tài khoản: <span className="font-semibold text-[#2F3945]">{dataUpdate.bank_number} - Ngân hàng {dataUpdate.bank_name}</span></span>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-2 sm:gap-3 mt-3 sm:mt-4">
            <div className="flex flex-col items-center gap-1.5">
              <button 
                onClick={() => copyToClipboardAndSendMailSMS(textUpdate)}
                className="w-full sm:w-auto min-w-[140px] sm:min-w-[160px] h-9 sm:h-10 px-4 sm:px-5 text-xs sm:text-sm font-semibold text-white bg-gradient-to-r from-blue-500 to-blue-600 rounded-[20px] sm:rounded-[25px] hover:from-blue-600 hover:to-blue-700 hover:scale-105 transition-all duration-200 cursor-pointer"
              >
                Sao chép nội dung
              </button>
              {copySuccess && (
                <p className="text-[11px] sm:text-xs text-green-600 font-medium">{copySuccess}</p>
              )}
            </div>
            <SendButton
              send_type={user.send_type}
              isMobile={isMobile}
              mailTo={mailTo}
              phoneNumber={phoneNumber}
              textUpdate={textUpdate}
            />
          </div>
        </div>
      );
    }
  }
}

export default DataConfirm;
